import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './About.css';

const About = () => {
    // Scroll to top on load
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-page">
            <SEO
                title="About Us | The Rent Company"
                description="Learn more about The Rent Company and our mission to redefine premium living."
            />
            <Navbar />

            <main className="about-main">
                {/* Hero Section */}
                <section className="about-hero">
                    <div className="about-hero-content">
                        <h1>Redefining <br /><span className="text-mustard">Premium</span> Living.</h1>
                        <p className="about-hero-subtitle">
                            We don't just find you a place to stay. We curate spaces that match your lifestyle, your ambition, and your need for sanctuary in the modern city.
                        </p>
                    </div>
                </section>

                {/* Our Story Grid */}
                <section className="about-story-section">
                    <div className="story-grid">
                        <div className="story-image-placeholder">
                            {/* In a real scenario, an image replacing this div */}
                            <div className="placeholder-content">Our Story</div>
                        </div>
                        <div className="story-text-content">
                            <h2>Born from the desire for <span className="text-mustard">better.</span></h2>
                            <p>
                                The Rent Company started with a simple observation: finding a premium rental property was more stressful than it needed to be. Endless searching, unreliable listings, and confusing terms left renters exhausted.
                            </p>
                            <p>
                                We envisioned a radically different approach—one rooted in transparency, cutting-edge technology, and an unwavering commitment to quality. Today, we manage thousands of exclusive properties, connecting discerning tenants with the homes they deserve.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Core Values */}
                <section className="about-values-section">
                    <div className="values-header">
                        <h2>Our Core <span className="text-mustard">Values</span></h2>
                        <p>The principles that guide every interaction, every listing, and every decision we make.</p>
                    </div>

                    <div className="values-grid">
                        <div className="value-card">
                            <div className="value-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                            </div>
                            <h3>Trust & Security</h3>
                            <p>Every property is verified. Every landlord is vetted. We prioritize your peace of mind above all else.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg>
                            </div>
                            <h3>Transparency</h3>
                            <p>No hidden fees. No misleading photos. What you see is exactly what you get, every single time.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            </div>
                            <h3>White-Glove Service</h3>
                            <p>From your first search to moving day and beyond, our dedicated team is here to support your journey.</p>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="about-cta">
                    <h2>Ready to find your next home?</h2>
                    <a href="/search" className="btn-primary">Browse Properties</a>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default About;
